import React, { useState, useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material UI
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

// Constants
import { REPORT_GROUPINGS } from 'constants/sellingTerminals';

// Actions
import { listEmployeesRequest } from 'store/ducks/employees/actions';
import { listLinesRequest } from 'store/ducks/lines/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyle from './groupingsModal.styles';

interface GroupingsInterface {
  key: string;
  value: string;
}

interface GroupingsModalInterface {
  selectedOptions: Array<string>;
  groupingOptions: Array<GroupingsInterface>;
  handleGrouping: (groups: Array<string>) => void;
  setOpenModal: (arg: boolean) => void;
}

type Props = GroupingsModalInterface;

const GroupingsModal: React.FC<Props> = ({
  groupingOptions,
  selectedOptions,
  handleGrouping,
  setOpenModal,
}) => {
  const classes = useStyle();
  const [options, setOptions] = useState(selectedOptions);

  const dispatch = useDispatch();

  const employeesList = useSelector(
    (state: ApplicationState) => state.employees.employeesList,
  );

  const linesList = useSelector(
    (state: ApplicationState) => state.lines.linesList,
  );

  useEffect(() => {
    if (options.includes(REPORT_GROUPINGS.PAYMENT.EMPLOYEE)) {
      dispatch(listEmployeesRequest({ body: { _limit: 9999 } }));
    }
    // eslint-disable-next-line
  }, [dispatch, options]);

  useEffect(() => {
    if (options.includes(REPORT_GROUPINGS.TRANSACTION.LINE_SECTION)) {
      dispatch(
        listLinesRequest({ body: { _limit: 9999, _includes: 'linesections' } }),
      );
    }
    // eslint-disable-next-line
  }, [dispatch, options]);

  const handleCheck = (key: string, selected: boolean) => {
    if (selected) {
      setOptions((prev) => {
        const index = prev.indexOf(key);
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });
    } else {
      setOptions((prev) => [...prev, key]);
    }
  };

  return (
    <div className={classes.root}>
      <DialogTitle>Agrupar por:</DialogTitle>
      <DialogContent>
        <List dense>
          {groupingOptions.map((item) => {
            const selected = !!options.find((o) => o === item.key);
            return (
              <ListItem key={item.key} button>
                <ListItemText
                  id={item.key}
                  primary={item.value}
                  classes={{ root: classes.itemText }}
                  onClick={() => handleCheck(item.key, selected)}
                />
                <ListItemSecondaryAction>
                  <Checkbox
                    edge='end'
                    color='primary'
                    checked={selected}
                    onChange={() => handleCheck(item.key, selected)}
                    inputProps={{ 'aria-labelledby': item.key }}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions className={classes.buttons}>
        <Button color='primary' onClick={() => setOpenModal(false)}>
          Cancelar
        </Button>
        <Button
          color='primary'
          variant='contained'
          onClick={() => handleGrouping(options)}>
          Agrupar
        </Button>
      </DialogActions>
    </div>
  );
};

export { GroupingsModal };
export default GroupingsModal;
